import { Component, OnInit, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { takeWhile } from 'rxjs/operators';
import { UserModel } from 'src/app/core/models/user.model';


@Component({
  selector: 'dum-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  @Input() isAuth: boolean;
  @Input() userLogged: UserModel;
  height: string = (window.screen.height - 162).toString() + 'px';
  constructor() {
   }

  ngOnInit(): void {
  }


}
